import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { observable, action, makeObservable } from 'mobx'

import Button from '../../../../UniformComponents/Button'
import Modal from '../../../../UniformComponents/Modal'
import FormController from '../../../form/FormController'

const defaultValues = {
    id: null,
    status: '',
    style: 'none',
    collapsible: false,
    enabled: false,
    textColor: '#2B3C44',
    bgColor: '#F8EEE5',
}
@observer
class StatusMsgEditModal extends Component {
    @observable formData = defaultValues

    @observable formFields = []

    validationFields = {}

    @observable isEdit

    constructor(props) {
        super(props)
        makeObservable(this)
    }

    componentDidMount() {
        const { msgId } = this.props
        this.isEdit = !!msgId
        this.loadForm(msgId)
        this.defineFormFields()
    }

    defineFormFields = () => {
        this.formFields = [
            {
                type: 'textarea',
                name: 'status',
                label: 'Status message',
                placeholder: 'Enter here',
                defaultValue: this.formData.status,
                isMandatory: true,
                errorMessage: 'Status message required',
                tooltipText: 'If adding an icon or link, do not use self-closing html tags',
            },
            {
                type: 'color-picker',
                name: 'textColor',
                label: 'Text colour',
                defaultValue: this.formData.textColor,
                showPreview: true,
            },
            {
                type: 'color-picker',
                name: 'bgColor',
                label: 'Header colour',
                defaultValue: this.formData.bgColor,
                showPreview: true,
            },
            {
                type: 'checkbox-reactive',
                cssClass: 'horizontal',
                name: 'options',
                label: 'Options',
                fields: [
                    {
                        type: 'checkbox',
                        label: 'Collapsible',
                        name: 'collapsible',
                        defaultChecked: this.formData.collapsible,
                    },
                    ...this.isEdit ? [{
                        type: 'checkbox',
                        label: 'Enabled',
                        name: 'enabled',
                        defaultChecked: this.formData.enabled,
                    }] : [],
                ],
            },
        ]
    }

    @action
    loadForm = (msgId) => {
        const { intranetStore } = this.props
        const data = msgId
            ? intranetStore.allServiceStatusMessages.find((ssm) => ssm.id === msgId)
            : null
        this.formData = data ? { ...data } : { ...defaultValues }
    }

    @action
    save = () => {
        const { onClose, intranetStore } = this.props
        const { id, enabled, ...data } = this.formData
        if (!this.isEdit) intranetStore.upsertServiceStatus(data)
        else intranetStore.upsertServiceStatus(this.formData)
        onClose()
    }

    @action
    setField = ({ name, value }) => {
        this.formData[name] = value
    }

    handleClose = () => {
        const { onClose } = this.props
        this.formData = { ...defaultValues }
        this.idEdit = false
        this.defineFormFields()
        onClose()
    }

    render() {
        return (
            <Modal id="msg-status-modal" show onClose={this.handleClose}>
                <div className="uc-modal__header">
                    <h2>{`${this.isEdit ? 'Edit' : 'Add'} status message`}</h2>
                </div>
                <br />
                <div className="form-wrapper">
                    <FormController
                        fields={this.validationFields}
                        formFields={this.formFields}
                        setField={this.setField}
                    />
                </div>
                <div className="btn-wrapper">
                    <Button
                        label="Cancel"
                        cssClass="tertiary regular"
                        onClick={this.handleClose}
                    />
                    <Button
                        label="Save"
                        cssClass="primary regular"
                        icon="fa-light fa-floppy-disk"
                        onClick={this.save}
                    />
                </div>
            </Modal>
        )
    }
}

export default StatusMsgEditModal
